/**
 * ISTAT AREA API — Wrapper dei REST Liferay delle aree ISTAT, in sola lettura (FILO-42, TS-124).
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET /istat-areas?level=N             (+ page, pageSize) -> Page<IstatArea>
 *   - GET /istat-area-geometries?level=N   -> Page<IstatAreaGeometry>, tutte in una risposta
 *         (+ minLatitude, minLongitude, maxLatitude, maxLongitude: solo quelle che toccano il
 *         rettangolo; obbligatori per i comuni, 400 oltre le 1.000 aree)
 */

import type { Page } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type { IstatArea, IstatAreaGeometry, IstatAreaRectangle } from './istatAreaTypes';

/** Le province sono 107: una pagina sola le contiene tutte. */
const PAGE_SIZE = 200;

export const istatAreaApi = {
  /** Le aree attive di un livello, senza poligono. */
  list: (level: number): Promise<IstatArea[]> =>
    httpClient.get<Page<IstatArea>>('/istat-areas', { params: { level, pageSize: PAGE_SIZE } })
      .then((r) => r.data.items),
  /**
   * I poligoni delle aree attive di un livello: tutte, o solo quelle che toccano il rettangolo.
   * Per i comuni il rettangolo serve sempre.
   */
  geometries: (level: number, rectangle?: IstatAreaRectangle): Promise<IstatAreaGeometry[]> =>
    httpClient.get<Page<IstatAreaGeometry>>('/istat-area-geometries',
      { params: { level, ...rectangle } })
      .then((r) => r.data.items),
};
